import { Routes } from '@angular/router';
import { AdminLayoutComponent, AuthLayoutComponent } from './core';
import { AuthGuard } from './services/shared/auth.guard';
export const AppRoutes: Routes = [
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: './session/session.module#SessionModule'
      }
    ]
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: './dashboard/dashboard.module#DashboardModule',
        canActivateChild: [AuthGuard]
      },
      {
        path: 'groupSchedule',
        loadChildren: './group-schedule/group-schedule.module#GroupScheduleModule',
        canActivateChild: [AuthGuard]
      },
      {
        path: 'sales',
        loadChildren: './sales-activity/sales-activity.module#SalesActivityModule',
        canActivateChild: [AuthGuard]
      }, {
        path: 'salesList',
        loadChildren: './sales-activity/sales-activity-list.module#SalesActivityListModule',
        canActivateChild: [AuthGuard]
      }, {
        path: 'account',
        loadChildren: './account/account.module#AccountModule',
        canActivateChild: [AuthGuard],
        data: { preload: true }
      }, {
        path: 'accountContracts',
        loadChildren: './account-contracts/account-contracts.module#AccountContractsModule',
        canActivateChild: [AuthGuard],
      },
      {
        path: 'accountFunction',
        loadChildren: './accountFunction/account-function.module#AccountFunctionModule',
        canActivateChild: [AuthGuard],
        data: { preload: true }
      },
      {
        path: 'accountGroup',
        loadChildren: './accountGroup/account-group.module#AccountGroupModule',
        canActivateChild: [AuthGuard]
      },
      {
        path: 'functionCalendar',
        loadChildren: './function-calendar/function-calendar.module#FunctionCalendarModule',
        canActivate: [AuthGuard]
      },
      {
        path: "functionSearch",
        loadChildren:
          "./function-search/function-search.module#FunctionSearchModule",
        canActivate: [AuthGuard],
      },
      {
        path: "reports",
        loadChildren:
          "./reports-page/reports.module#ReportsModule",
        canActivate: [AuthGuard],
      },
      {
        path: 'grc',
        loadChildren: './group-rooms-control/group-rooms-control.module#GroupRoomsControlModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'propertyDocuments',
        loadChildren: './property-documents/property-documents.module#PropertyDocumentsModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'users',
        loadChildren: './user-accounts/user-accounts.module#UserAccountsModule',
        canActivate: [AuthGuard]
      }, {
        path: 'cateringOptions',
        loadChildren: './catering-option/catering-options.module#CateringOptionsModule',
        canActivate: [AuthGuard]
      }, {
        path: 'systemActivities',
        loadChildren: './system-activities/system-activities.module#SystemActivitiesModule',
        canActivate: [AuthGuard]
      }, {
        path: 'helpCenter',
        loadChildren: './core/tech-support/help-center/help-center.module#HelpCenterModule',
        canActivate: [AuthGuard]
      }
    ],
  },
  {
    path: '**',
    redirectTo: 'session/signin'
  }
];



// WEBPACK FOOTER //
// ./src/app/app.routing.ts